export interface FeatureFlagModel {
  id: number;
  name: string;
  description: string;
  enabled: boolean;
  featureFlagTypeId: number;
}

export interface UpdateFeatureFLagPayload {
  featureFlagId: number;
  enabled: boolean;
}

/**
 * Feature flags for the application (Aligns w/ the FeatureFlag table).
 */
export enum FeatureFlagName {
  Programs = 'Programs',
  BlackbaudId = 'BlackbaudId',
  LiveChat = 'LiveChat',
  PopulationServed = 'PopulationServed',
  SystemQuestions = 'SystemQuestions',
  RENXT = 'RENXT',
  ExpeditedGiving = 'ExpeditedGiving',
  TrueImpactReporting = 'TrueImpactReporting'
}

/**
 * Feature flag types for the application (Aligns w/ the FeatureFlagTypes table).
 */
export enum FeatureFlagType {
  Site = 1,
  Nonprofit = 2
}
